module.exports = __webpack_public_path__ + "media/1.a6a3a393.mp3";